<div [formGroup]="group" [class.columns]="columns">
    <h2 *ngIf="config.title">{{ config.title }}</h2>
    <div *ngFor="let traveller  of group.controls; let i = index"
         [formGroupName]="i"
         class="cf traveller-ctn list-row e2e-traveller-fieldset-{{i}}"
         [class.onlyOne]="group.controls.length === 1">
        <div class="field-sep">
            <strong class="key" *ngIf="!getName(i)">{{wording.traveller}} {{ (i + 1) }}</strong>
            <strong class="key" *ngIf="getName(i)">{{getName(i)}}</strong>
        </div>
        <div [formGroup]="traveller" class="col-to-row-s-tb e2e-div-traveller" >
            <div class="field-sep flex-1 e2e-title-field">
                <combobox-field [fieldConfig]="{formGroup : fieldsConfig[i].type.formGroup,
                                    disabled: isTravellerReadonly[i],
                                    formControlName: fieldsConfig[i].title.formControlName,
                                    label: fieldsConfig[i].title.label,
                                    placeholder: fieldsConfig[i].title.label,
                                    validators: fieldsConfig[i].title.validators}"
                                [items]="options"
                                (onOptionSelection)="blurField(fieldsConfig[i].title)"></combobox-field>
            </div>
            <div class="field-sep flex-2 e2e-last-name-field">
                <text *ngIf="i === 0"
                      [fieldConfig]="fieldsConfig[i].lastName"
                      (onBlur)="blurField(fieldsConfig[i].lastName); setLastName($event)"
                      (onFocus)="testLastNames()"></text>
                <text *ngIf="i !== 0"
                      [fieldConfig]="fieldsConfig[i].lastName"
                      (onBlur)="blurField(fieldsConfig[i].lastName)"></text>
            </div>
            <div class="sep-bottom flex-2 e2e-first-name-field">
                <text [fieldConfig]="fieldsConfig[i].firstName"
                      (onBlur)="blurField(fieldsConfig[i].firstName)"></text>
            </div>
        </div>
        <div class="col-to-row-s-tb">
            <div class="field-sep flex-1 e2e-paxtype-field">
                <combobox-field [fieldConfig]="{formGroup : fieldsConfig[i].type.formGroup,
                                    disabled: isTravellerReadonly[i] || disableTypes,
                                    formControlName: fieldsConfig[i].type.formControlName,
                                    label: fieldsConfig[i].type.label,
                                    validators: fieldsConfig[i].type.validators}"
                                [items]="optionsType"
                                (onOptionSelection)="updateDateConfig();blurField(fieldsConfig[i].type)"></combobox-field>

            </div>
            <div class="flex-4 sep-bottom e2e-birthdate-field">
                <date-field [fieldConfig]="fieldsConfig[i].birthDate"
                            (select)="blurField(fieldsConfig[i].birthDate)"
                            (blur)="blurField(fieldsConfig[i].birthDate)"
                            [yearNavigator]="true"
                            [monthNavigator]="true"
                            [onlyOneMonth]="true"
                ></date-field>
            </div>

        </div>
        <div class="col-to-row-s-tb"
             *ngIf="apisForm && (travellerCollapse.link === 1) && !apiServiceQualityMessage?.length">
            <div class="set-marge-bottom">
                <btnForm styleType="actionLink e2e-apis-btn" formType="button" (click)="setOpenApis(i)">
                    {{wording.apisInput}}&nbsp;
                    <fa-icon [icon]="getOpenApis(i) ? iconCaretDown : iconCaretRight"></fa-icon>
                </btnForm>
            </div>
        </div>
        <identity-info-editor #identityInfoEditorComponent
                              *ngIf="(apisForm && (travellerCollapse.link === 0 || getOpenApis(i))) || apiServiceQualityMessage?.length"
                              [hasNoneOption]="true"
                              [hasBirthDateField]="false"
                              [apiServiceQualityMessage]="apiServiceQualityMessage"
                              [travellerFormGroup]="traveller"
                              [initialIdentityInfoType]="travellerItem[i]|getTravellerIdentityInfoDisplayMode"
                              [initialGender]="traveller.value['title']|titleToGender"
                              [initialBirthDate]="travellerItem[i].birthDate"
                              [isTravellerReadonly]="isTravellerReadonly[i]"
                              [initialPassport]="initialPassport[i]"
                              [initialIdentityCard]="initialIdentityCard[i]"
                              (onBlur)="blurPassportField($event)"></identity-info-editor>
    </div>

</div>
